import React, { useState } from "react";
import { Alert } from "antd";
import ShipmentRequirementsSummary from "../ShipmentRequirementsSummary";
import EnterExchangeETAsInputForm from "./EnterExchangeETAsInputForm";

const EnterExchangeETAs = props => {
  const {
    exchangeShipmentData,
    mainShipmentData,
    createSingleShipmentPropertyValueUpdater,
    setReturningFromExchangeShipment,
  } = props;

  const [hasReviewedRequirements, setHasReviewedRequirements] = useState(false);
  const [hasScrolledToBottomOfRequirements, setHasScrolledToBottomOfRequirements] = useState(false);

  const handleReviewRequirementsChecked = checked => {
    setHasReviewedRequirements(checked);
    setHasScrolledToBottomOfRequirements(hasScrolledToBottomOfRequirements || checked);
  };

  if (!exchangeShipmentData) return null;

  return (
    <>
      <ShipmentRequirementsSummary
        shipmentsList={[exchangeShipmentData]}
        hasCheckedAllVehicles={hasReviewedRequirements}
        setHasCheckedAllVehicles={handleReviewRequirementsChecked}
        setHasScrolledToBottomOfRequirements={setHasScrolledToBottomOfRequirements}
      />

      {!hasReviewedRequirements ? (
        <div style={{ marginTop: "16px" }}>
          <Alert
            type="warning"
            banner
            message="Please scroll to the bottom of the list above, and check the box to continue."
          />
        </div>
      ) : (
        <div style={{ height: "54px" }} />
      )}

      <EnterExchangeETAsInputForm
        exchangeShipmentData={exchangeShipmentData}
        mainShipmentData={mainShipmentData}
        createSingleShipmentPropertyValueUpdater={createSingleShipmentPropertyValueUpdater}
        setReturningFromExchangeShipment={setReturningFromExchangeShipment}
        confirmDisabled={!hasReviewedRequirements}
      />
    </>
  );
};

export default EnterExchangeETAs;
